import { 
  statusLegalAndRegTextStart,
  statusLegalAndRegTextSuccess,
  statusLegalAndRegTextFailure 
} from "./legalAndRegulatorTextSlice";

import { getCustom, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getLegalAndRegTextApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusLegalAndRegTextStart())    
    const response = await getCustom(`legal_and_reg_text`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusLegalAndRegTextSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusLegalAndRegTextFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusLegalAndRegTextFailure(errData))
      return [errData]
    }
  }
}

export const AddLegalAndRegTextApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusLegalAndRegTextStart())
    const response = await post(`legal_and_reg_text`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusLegalAndRegTextSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusLegalAndRegTextFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusLegalAndRegTextFailure(errData))
      return [errData]
    }
  }
}

export const EditLegalAndRegTextApi = (legal_and_reg_textId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusLegalAndRegTextStart())
    const response = await put(`legal_and_reg_text/${legal_and_reg_textId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusLegalAndRegTextSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusLegalAndRegTextFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusLegalAndRegTextFailure(errData))
      return [errData]
    }
  }
}

export const DeleteLegalAndRegTextApi = (legal_and_reg_textId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusLegalAndRegTextStart())
    const response = await remove(`legal_and_reg_text/${legal_and_reg_textId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusLegalAndRegTextSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusLegalAndRegTextFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusLegalAndRegTextFailure(errData))
      return [errData]
    }
  }
}


export const clearLegalAndRegTextApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusLegalAndRegTextSuccess([]))
}
